export default __webpack_public_path__ + "static/media/verify-certificate-home.74316aaf.svg";